import React from 'react';
import { Spinner } from 'react-bootstrap';

function CardLoadingPage() {
  return (
    <div className={`card custom-card w-100 shadow`}>
      <div className='p-5'>
        <div className={`container d-flex justify-content-center align-items-center`} style={{minHeight: '700px'}}>
          <div className='text-center'>
          <Spinner className='fs-1 ' animation="border" role="status" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardLoadingPage;
